import { defineMessages } from 'react-intl';

const _default_1: {
	labelCancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelEsc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	labelCancel: {
		id: 'fabric.editor.ai.components.cancelEscButton.cancelLabel',
		defaultMessage: 'Cancel',
		description:
			'Label for the Cancel button in the CancelEsc component of the generative AI modal, allowing users to cancel the current AI operation.',
	},
	labelEsc: {
		id: 'fabric.editor.ai.components.cancelEscButton.escLabel',
		defaultMessage: 'Esc',
		description:
			'Label for the Esc button in the CancelEsc component of the generative AI modal, indicating the keyboard shortcut to dismiss the modal.',
	},
});
export default _default_1;
